import { useFormField } from '@calendly/form'
import { useInputId } from '@calendly/form/parts'
import { I18n } from '@calendly/i18n'

import { FieldWrapper, FieldLabel, FieldInput } from './field_parts'

export const SubjectField = () => {
  const id = useInputId()
  const [fieldProps, meta] = useFormField({ name: 'subject' })
  const error = meta.touched && meta.error

  return (
    <FieldWrapper invalid={Boolean(error)}>
      <FieldLabel htmlFor={id}>
        {I18n.t('publisher.send_from_calendly.fields.subject.name')}
        <span aria-hidden>:</span>
      </FieldLabel>
      <FieldInput
        id={id}
        placeholder={I18n.t('publisher.send_from_calendly.fields.subject.no_subject')}
        maxLength={255}
        {...fieldProps}
      />
    </FieldWrapper>
  )
}
